import { registerPlugin, Capacitor } from '@capacitor/core';

const Badge = registerPlugin('Badge');

/**
 * The app icon's badge, driven by the real unread count.
 *
 * Previously the only thing that could set a badge was an arriving push, and the
 * payload hardcoded 1 — so it meant "something arrived", not "you have N
 * unread", and it never cleared when you read things on the website or in
 * another session. Setting it from the count the app already polls keeps it
 * honest in both directions.
 *
 * No-ops on web: browsers have navigator.setAppBadge, but only for installed
 * PWAs, and a silent failure there is fine.
 */
export async function setAppBadge(count) {
  const n = Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
  if (!Capacitor.isNativePlatform()) return;
  try {
    await Badge.set({ count: n });
  } catch {
    // Older build without the plugin — not worth surfacing.
  }
}
